var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{on:{"click":_vm.logout}},[_c('v-list-item-avatar',[_c('v-icon',[_vm._v("mdi-exit-to-app")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_c('p',[_vm._v("Salir")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }